<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="4">
        <v-card color="blue darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2">mdi-home-city</v-icon>
            <v-divider vertical class="mr-2" />
            <span>Prefeituras:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <h1 class="fsl">{{ data.prefectures }}</h1>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card color="orange darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2">mdi-car</v-icon>
            <v-divider vertical class="mr-2" />
            <span>Veiculos:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <h1 class="fsl">{{ data.vehicles }}</h1>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card color="purple darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2">mdi-gas-station</v-icon>
            <v-divider vertical class="mr-2" />
            <span>Fornecedores:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <h1 class="fsl">{{ data.providers }}</h1>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card class="text-center">
          <v-card-title class="body-1"
            >QUANTITATIVO MÊS ATUAL ABASTECIMENTOS</v-card-title
          >
          <v-card-text>
            <pie-chart height="650px" :data="data.newSuppliesMonth"></pie-chart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card class="text-center">
          <v-card-title class="body-1"
            >QUANTITATIVO ANO ABASTECIMENTOS</v-card-title
          >
          <v-card-text>
            <pie-chart height="650px" :data="data.newSuppliesYear"></pie-chart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Helpers from "../../mixins/helpers";
export default {
  props: ["prefecture_id"],
  mixins: [Helpers],
  created() {
    this.Helpers;
    this.initialize();
  },
  data: () => ({
    data: {
      prefectures: 0,
      providers: 0,
      vehicles: 0,
      newSuppliesMonth: [],
      newSuppliesYear: [],
    },
    chartOptions: {
      backgroudColor: "blue",
    },
  }),
  methods: {
    initialize() {
      if (this.prefecture_id) {
        this.$http(`/dashboard/prefectures/${this.prefecture_id}`).then(
          (r) => (this.data = r.data)
        );
      } else {
        this.$http(`/dashboard`).then((r) => (this.data = r.data));
      }
    },
  },
};
</script>

<style>
</style>